import { Amplify } from "aws-amplify";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: "ap-south-1_2K1BSztXU",
      userPoolClientId: "5942pq5kc36r660l3mjvifk6it",
      loginWith: {
        username: true,
      },
    },
  },
});